/* eslint-disable no-unused-vars */
import { get, reset } from 'lib/sequence/component/state/value'
import { disable, enable } from 'lib/sequence/component/state/disabled'

/**
 * Enables/Disables the `installedByName` field depending on the value of `installerIs`
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
export default module => async (components, ...args) => {
  const { installerName, installerIs } = components

  get(installerIs) === 'another'
    ? enable(installerName)
    : reset(installerName) && disable(installerName)

  return [components, ...args]
}
